module.exports = __webpack_public_path__ + "assets/img/mecha-btn-c0d3d598.png";